import React from 'react'
import './SpecialOffers.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import Hero from '../Hero/Hero'

function SpecialOffers() {
  return (
    <>
      <Hero />
      <div className="SpecialOffers">
        <div className="SpeacialOffers-Container DefaultSection DefaultContainer">
          <SectionTitle title="Условия для гостей с ограниченными возможностями." />
          <p>
            Наша гостиница создает комфортные условия для всех категорий гостей,
            в том числе для людей с ограниченными возможностями и маломобильных
            групп населения (МГН).
          </p>
          <p className="Bolder">Доступность территории и здания</p>
          <p>
            Вход в гостиницу: Расширенный входной дверной проём
            <br />
            Передвижение по зданию: Широкие коридоры 1 этажа <br />
            Парковка: Расположение вблизи входа в здание <br />
          </p>
          <p className="Bolder">Дополнительные услуги</p>
          <p>
            Размещение с собакой-поводырем (бесплатно); Помощь персонала при
            заселении и перемещении по территории; Помощь в вызове такси,
            адаптированного для перевозки людей с ограниченными возможностями.
          </p>
          <p className="Bolder">Условия бронирования </p>
          <p>
            Для обеспечения максимального комфорта просим вас: <br />
            Сообщайте о необходимости специализированного номера при
            бронировании;
            <br />
            Укажите особые потребности и требования к размещению;
            <br />
            Уведомлять о необходимости предоставления дополнительных услуг не
            менее чем за 72 часа до заселения
          </p>
          <p>
            <b>
              Наш персонал готов ответить на все вопросы и помочь организовать
              комфортное пребывание для каждого гостя.
            </b>
          </p>
        </div>
      </div>
    </>
  )
}

export default SpecialOffers
